import { MouseEventHandler } from "react";
import { useUserPreference } from "@coworker/app/src/hooks/useProfilePreferencesQuery";
import profilePreferences from "@coworker/enums/profilePreferences";
import { ProductSearchHistorySkeleton } from "./ProductSearchHistorySkeleton";
import { ProductSearchHistoryPresentation } from "./ProductSearchHistoryPresentation";
import { Dispatch, SetStateAction } from "react";
import ProductSearchCss from "../../pages/product-search-page/product-search.module.css";
import { Trans } from "@coworker/locales";

interface ProductSearchHistoryProps {
  hideHistory: boolean;
  setSearchQuery: Dispatch<SetStateAction<string>>;
  onHistoryItemMouseDown?: MouseEventHandler<HTMLDivElement> | undefined;
}

export const ProductSearchHistory = ({
  hideHistory,
  setSearchQuery,
  onHistoryItemMouseDown,
}: ProductSearchHistoryProps) => {
  const [searchHistory, setSearchHistory, isLoading] = useUserPreference<
    string[]
  >(profilePreferences.SEARCH_HISTORY, []);

  if (isLoading) {
    return <ProductSearchHistorySkeleton />;
  }

  if (searchHistory.length < 1 && !hideHistory)
    return (
      <div className={ProductSearchCss["search-for-articles"]}>
        <div className={ProductSearchCss["search-for-articles-header"]}>
          <Trans>searchForArticlesString</Trans>
        </div>
        <span className={ProductSearchCss["search-for-articles-description"]}>
          <Trans>searchForArticlesInstructionsString</Trans>
        </span>
      </div>
    );

  if (hideHistory) return null;

  const handleDeleteHistoryItem = (historyItem: string) => {
    setSearchHistory(searchHistory.filter((item) => item !== historyItem));
  };

  const handleClearHistory = () => setSearchHistory([]);

  const onHistoryItemClick = (historyItem: string) => {
    setSearchQuery(historyItem);
    setSearchHistory([
      historyItem,
      ...searchHistory.filter((item) => item !== historyItem),
    ]);
  };

  return (
    <ProductSearchHistoryPresentation
      searchHistory={searchHistory}
      onDeleteHistoryItem={handleDeleteHistoryItem}
      onClearHistory={handleClearHistory}
      onHistoryItemClick={onHistoryItemClick}
      onHistoryItemMouseDown={onHistoryItemMouseDown}
    />
  );
};
